var _defs, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-77fe31a8-a7b0-4d9d-872e-7d1a48843049",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-30f6475c-8044-4c67-ba83-a158b55f4066 {\n        fill: #f2f2f2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-30f6475c-8044-4c67-ba83-a158b55f4066",
    points: "16.29 17.87 22.91 8.42 19.71 8.42 14.69 15.59 16.29 17.87"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-30f6475c-8044-4c67-ba83-a158b55f4066",
    points: "12.29 23.58 13.89 21.3 12.29 19.01 9.09 23.58 12.29 23.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-30f6475c-8044-4c67-ba83-a158b55f4066",
    points: "16.29 23.58 19.49 23.58 12.29 13.3 9.09 13.3 16.29 23.58"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-30f6475c-8044-4c67-ba83-a158b55f4066",
    points: "22.91 9.56 20.29 13.3 20.55 23.58 22.65 23.58 22.91 9.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAi);
export default __webpack_public_path__ + "static/media/xAI.9e7dfca1b0f042dd3d69a0cb00a47a0f.svg";
export { ForwardRef as ReactComponent };